// Click-to-play for product gallery video.
//
// The markup carries preload="none" and no autoplay, so nothing is fetched
// until the shopper asks. A play badge sits over the poster so it is obvious
// the frame is a video and not a still.
(function () {
  function wrap(video) {
    if (video.dataset.oliviaClickBound) return;
    video.dataset.oliviaClickBound = '1';

    var host = video.parentElement;
    if (host && getComputedStyle(host).position === 'static') host.style.position = 'relative';

    var badge = document.createElement('button');
    badge.type = 'button';
    badge.className = 'olivia-video-play';
    badge.setAttribute('aria-label', 'Play video');
    badge.innerHTML = '<span></span>';

    function start() {
      badge.remove();
      video.setAttribute('controls', '');
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    badge.addEventListener('click', function (e) { e.preventDefault(); start(); });
    video.addEventListener('click', function () { if (video.paused) start(); });
    if (host) host.appendChild(badge);
  }

  function scan(root) {
    (root || document).querySelectorAll('video.olivia-video-click').forEach(wrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

// 05.10.2026: video posters are fetched by the browser at once even with preload="none", so the unboxing,
// "See it in motion", homepage and card hover posters (~150 KB on a product page) competed with the first
// product photo on 4G. Templates now write data-poster; it becomes a real poster after the page has loaded,
// or earlier when the video comes near the screen.
(function () {
  function set(v) { if (v.dataset.poster) { v.poster = v.dataset.poster; v.removeAttribute('data-poster'); } }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { set(e.target); io.unobserve(e.target); } });
  }, { rootMargin: '300px' }) : null;
  var loaded = document.readyState === 'complete';
  function scan(root) {
    (root || document).querySelectorAll('video[data-poster]').forEach(function (v) { if (loaded || !io) set(v); else io.observe(v); });
  }
  window.addEventListener('load', function () { setTimeout(function () { loaded = true; scan(); }, 300); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
  new MutationObserver(function (muts) {
    muts.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); }); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
